import React, { useState, useRef, useEffect } from 'react'

import { useAuth } from '../../../../hooks/auth'
import { MenuLogo } from './components/MenuLogo'
import { MenuPatentLink } from './components/MenuPatentLink'
import { MenuReestrLink } from './components/MenuReestrLink'
import { MenuHamburger } from './components/MenuHamburger'
import { MenuLoginLink } from './components/MenuLoginLink'
import { MenuPriceLink } from './components/MenuPriceLink'
import { MenuNavigation } from './components/MenuNavigation'

const Menu: React.FC = () => {
    const [hoverMenuHeader, setHoverMenuHeader] = useState(false)

    const [isOpen, setIsOpen] = useState(false)
    const [isHover, setIsHover] = useState(false)
    const menuRef = useRef<HTMLDivElement>(null)

    const [showStickyButton, setShowStickyButton] = useState(false)

    const { user } = useAuth()

    // Закрытие при клике вне
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            console.log('click outide')
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target as Node)
            ) {
                setIsOpen(false)
            }
        }

        const handleScroll = () => {
            if (isOpen) {
                setIsOpen(false)
            }

            // 👉 Проверяем scrollY
            if (window.scrollY > 800) {
                setShowStickyButton(true)
            } else {
                setShowStickyButton(false)
            }
        }

        document.addEventListener('click', handleClickOutside)
        window.addEventListener('scroll', handleScroll)

        return () => {
            document.removeEventListener('click', handleClickOutside)
            window.removeEventListener('scroll', handleScroll)
        }
    }, [isOpen])

    return (
        <div
            className={`fixed flex flex-col w-full z-[55] items-center justify-center duration-300 transform transition-all ${hoverMenuHeader || isOpen ? 'bg-[#f0f3f5]' : 'bg-[#f0f3f5d5] backdrop-blur-sm'} `}
            onMouseEnter={() => setHoverMenuHeader(true)}
            onMouseLeave={() => setHoverMenuHeader(false)}
        >
            <div className="flex flex-row w-full max-w-[1200px] items-center px-5 md:px-0 py-5 gap-3 z-[56]">
                <MenuLogo />
                <MenuReestrLink className="hidden md:flex lg:ml-3" />
                <MenuPatentLink className="hidden md:flex lg:ml-3" />

                <div className="grow"></div>

                <MenuPriceLink
                    className={
                        'hidden md:flex ' +
                        (!user && showStickyButton
                            ? ''
                            : 'opacity-0 cursor-default')
                    }
                />
                <MenuLoginLink className="hidden md:flex" />
                <div
                    className="rounded-full"
                    onPointerEnter={() => setIsHover(true)}
                    onPointerLeave={() => setIsHover(false)}
                    onPointerDown={() => setIsHover(true)}
                    onPointerUp={() => setIsHover(false)}
                    onPointerCancel={() => setIsHover(false)}
                >
                    <MenuHamburger
                        isOpen={isOpen}
                        isHover={isHover}
                        onClick={() => setIsOpen((prev) => !prev)}
                    />
                </div>
            </div>

            <div
                ref={menuRef}
                className={`md:absolute flex top-[72px] w-full bg-[#f0f3f5] items-center justify-center shadow-md z-55 transform transition-all duration-500 ease-in-out overflow-hidden ${
                    isOpen
                        ? 'md:max-h-[300px] opacity-100'
                        : 'max-h-0 opacity-0'
                }`}
            >
                <div className="flex flex-col w-full max-w-[1200px] md:h-72 items-start justify-start py-[10px]">
                    <div className="flex md:hidden flex-col w-full mb-5 items-start justify-start gap-3 pl-5">
                        <MenuReestrLink className="flex" />
                        <MenuPatentLink className="flex" />
                    </div>
                    <MenuNavigation onClick={() => setIsOpen(false)} />
                </div>
            </div>
        </div>
    )
}

export default Menu
